import { Help } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	FormControl,
	FormControlLabel,
	FormHelperText,
	FormLabel,
	Radio,
	RadioGroup,
	Stack,
} from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { enumT } from '../../../../../utils/helper';
import MarkdownRenderer from '../../../markdown-renderer/MarkdownRenderer';
import MUIToolTip from '../../../mui-tooltip/MUIToolTip';

const MUIRadioField: FC<MUIFieldProps> = (props) => {
	const { label, tooltip, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;
	const isAccordion = get(props, 'display') === 'accordion';
	const [expandedId, setExpandedId] = React.useState<number | false>(0);

	const renderOptions = (options: any[], isEnum: boolean = false) => {
		if (!isAccordion) {
			return (
				<Stack direction={get(props, 'direction', 'row')} flexWrap='wrap' gap={2}>
					{options.map((ele: any, i: number) => (
						<FormControlLabel
							disabled={isDisabled}
							key={i}
							value={isEnum ? ele : get(ele, 'value')}
							control={<Radio sx={{ paddingTop: 0 }} />}
							label={isEnum ? <MarkdownRenderer markdown={enumT(`${ele}`)} /> : <MarkdownRenderer markdown={get(ele, 'label', '')} />}
							sx={{ alignItems: 'flex-start' }}
						/>
					))}
				</Stack>
			);
		}

		return options.map((ele: any, i: number) => {
			const value = isEnum ? ele : get(ele, 'value');
			const label = isEnum ? <MarkdownRenderer markdown={enumT(`${ele}`)} /> : <MarkdownRenderer markdown={get(ele, 'label', '')} />;
			const description = isEnum ? get(props, `descriptions.${ele}`) : get(ele, `descriptions.${value}`);

			return (
				<Accordion
					key={i}
					expanded={expandedId === i}
					onChange={(_, isExpanded) => setExpandedId(isExpanded ? i : false)}
					defaultExpanded
					sx={{ background: '#fff', border: '1px solid', borderRadius: '0 !important' }}
				>
					<AccordionSummary
						expandIcon={expandedId === i ? <RemoveIcon /> : <AddIcon />}
						sx={{ '& .MuiAccordionSummary-content': { margin: 0 } }}
					>
						<FormControlLabel
							onClick={(e) => e.stopPropagation()}
							disabled={isDisabled}
							value={value}
							control={<Radio checked={fieldValue === value} onChange={updateFieldValue} />}
							label={label}
						/>
					</AccordionSummary>
					{description && (
						<AccordionDetails sx={{ padding: '0 3rem 1rem' }}>
							<MarkdownRenderer markdown={description} />
						</AccordionDetails>
					)}
				</Accordion>
			);
		});
	};

	return (
		<>
			<FormControl fullWidth error={error} sx={{ mt: '1rem' }}>
				<FormLabel sx={{ mb: '0.5rem' }}>
					{tooltip ?
						<>
							<>{label}</>
							<MUIToolTip title={tooltip}>
								{' '}
								<Help fontSize='small' color='primary' sx={{ ml: '5px' }} />{' '}
							</MUIToolTip>
						</>
					:	<>{label}</>}
				</FormLabel>
				<RadioGroup
					aria-label='demo-controlled-radio-buttons-group'
					value={fieldValue}
					onChange={!isAccordion ? updateFieldValue : undefined}
					{...restProps}
				>
					{get(props, 'options') ?
						renderOptions(get(props, 'options', []))
					: get(props, 'enum') ?
						renderOptions(get(props, 'enum', []), true)
					:	<Stack direction={get(props, 'direction', 'row')} flexWrap='wrap' gap={2}>
							<FormControlLabel disabled={isDisabled} value={true} control={<Radio />} label={'Ja'} />
							<FormControlLabel disabled={isDisabled} value={false} control={<Radio />} label={'Nein'} />
						</Stack>
					}
				</RadioGroup>
			</FormControl>
			{error && <FormHelperText error>{errorMessage}</FormHelperText>}
		</>
	);
};

export default MUIRadioField;
